import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { DraftAccountDTO } from '../../../AccountOpening.meta';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { MarginProps, PaddingProps } from '../../../../../theme/styledProps';
import { EditableField } from '../../../components/EditableField/EditableField';
import { getIncomeOption, incomeOpts } from '../NetWorthFields.meta';

interface Props extends MarginProps, PaddingProps {
  isReview?: boolean;
  draftAccount: DraftAccountDTO;
}

export const AnnualIncome: React.FC<Props> = ({ isReview, draftAccount, ...rest }) => {
  const formBag = useFormContext();

  const { annualIncomeUSDMin, annualIncomeUSDDefault } = draftAccount;

  const [isEditing, setIsEditing] = useState(!isReview);

  const [incomeOpt, setIncomeOpt] = useState(() =>
    getIncomeOption(annualIncomeUSDMin, annualIncomeUSDDefault, incomeOpts),
  );

  if (!isEditing) {
    return <EditableField onEdit={() => setIsEditing(true)}>{incomeOpt.label}</EditableField>;
  }

  return (
    <Box {...rest}>
      <input
        defaultValue={incomeOpt.value.min}
        type="hidden"
        {...formBag.register('annualIncomeUSDMin', { valueAsNumber: true })}
      />
      <input
        defaultValue={incomeOpt.value.max}
        type="hidden"
        {...formBag.register('annualIncomeUSDMax', { valueAsNumber: true })}
      />

      <Select
        value={incomeOpt}
        label={isReview ? undefined : 'Estimated Annual Income'}
        onChange={opt => {
          if (opt) {
            formBag.setValue('annualIncomeUSDMin', opt.value.min);
            formBag.setValue('annualIncomeUSDMax', opt.value.max);

            setIncomeOpt(opt);
          }
        }}
        options={incomeOpts}
        aria-label="Estimated Annual Income"
      />
    </Box>
  );
};
